import { Link } from "react-router-dom";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  action?: { label: string; to: string };
}

export default function SectionHeading({ eyebrow, title, description, action }: SectionHeadingProps) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-6 md:mb-8">
      <div>
        {eyebrow && (
          <p className="font-label text-xs tracking-[0.32em] text-primary-500 uppercase mb-2">
            {eyebrow}
          </p>
        )}
        <h2 className="font-heading text-xl md:text-[26px] text-foreground-950 font-semibold leading-tight">
          {title}
        </h2>
        {description && (
          <p className="mt-2 text-sm text-foreground-600 max-w-2xl leading-relaxed">{description}</p>
        )}
      </div>
      {action && (
        <Link
          to={action.to}
          className="inline-flex items-center gap-1.5 text-sm text-primary-500 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer shrink-0"
        >
          {action.label}
          <i className="ri-arrow-right-line text-base" aria-hidden="true"></i>
        </Link>
      )}
    </div>
  );
}